import {  useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import "./scss/report.scss"
import { Table, Spin , Tabs} from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";
import { Tooltip } from "antd";

const { TabPane } = Tabs;

const ReportTvOnline = () => {
    const title = "Báo cáo tổng quan Sale"
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [totalPaid, setTotalPaid] = useState(0)
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0)
    const [totalService, setTotalService] = useState(0)
    const [totalOrder, setTotalOrder] = useState(0)
    const [arrayThuan, setArrayThuan] = useState([])
    const [totalThuanOb, setTotalThuan] = useState({
        triet_thuan: 0,
        da_thuan: 0,
        body_thuan: 0,
        my_pham_thuan: 0,
        dau_triet_thuan: 0,
        goi_thuan: 0,
    })

    const [totalThucThu, setTotalThucThu] = useState({
        triet_thuc_thu: 0,
        da_thuc_thu: 0,
        body_thuc_thu: 0,
        my_pham_thuc_thu: 0,
        dau_triet_thuc_thu: 0,
        goi_thuc_thu: 0,
    })

    const [totalThucThuNoTax, setTotalThucThuNoTax] = useState({
        triet_thuc_thu_no_tax: 0,
        da_thuc_thu_no_tax: 0,
        body_thuc_thu_no_tax: 0,
        my_pham_thuc_thu_no_tax: 0,
        dau_triet_thuc_thu_no_tax: 0,
        goi_thuc_thu_no_tax: 0,
    })

    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
   
    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }
    const fetchData = async (sD, eD, s) => {
        const { data } = await async.parallel({
            data: (cb) => {
                axiosService(`api/mysql/transaction/sales?start=${sD}&end=${eD}&store=${store}&keyword=${keyword}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const {totalPaid, totalPaidNoTax, totalService, totalOrder, dataChart, dataTable, arrayThuan, totalThuan , totalThucThu, totalThucThuNoTax} = data.data

            setTable(dataTable)
            setTotalPaid(totalPaid)
            setTotalPaidNoTax(totalPaidNoTax)
            setTotalService(totalService)
            setTotalOrder(totalOrder)
            setTotalThuan(totalThuan)
            setArrayThuan(arrayThuan)
            setTotalThucThu(totalThucThu)
            setTotalThucThuNoTax(totalThucThuNoTax)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store,keyword])


    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    const columns = [
        {
            title: 'Nhân viên',
            dataIndex: 'user_name',
            fixed: 'left',
            render: (data) => {
                return (
                    <>
                        <p>{data}</p>
                    </>
                )
            },
            sorter: (a, b) => a.user_name.length - b.user_name.length,
        },
        {
            title: 'Số đơn hàng thuần',
            dataIndex: 'count_order_ss',
            align: "center",
            sorter: {
                compare: (a, b) => a.count_order_ss - b.count_order_ss,
                multiple: 3,
            },
        },
        {
            dataIndex: 'total_price',
            title: <Tooltip className="show-tooltip" title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'> Doanh số thuần <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.total_price) - Number(b.total_price),
                multiple: 1,
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Số tiền khách hàng đã thanh toán hoá đơn được lên đơn trong khoảng thời gian chọn. Đơn hàng khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'> Thực thu đơn hàng thuần <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'paid',
            align: "center",
            with: 180,
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.paid) - Number(b.paid),
                multiple: 1,
            },
        },
        {
            title: 'Số dịch vụ thuần',
            dataIndex: 'count_service',
            align: "center",
            sorter: {
                compare: (a, b) => a.count_service - b.count_service,
                multiple: 2,
            },
        },
        {
            title: 'AOV đơn hàng thuần',
            dataIndex: 'ratio',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Đơn hàng bị huỷ',
            dataIndex: 'count_auto_cancel',
            title: <Tooltip className="show-tooltip" title='Tổng số đơn hàng Online lên đơn cho khách hàng có nhu cầu nhưng khách hàng không đến hệ thống tự huỷ.'> Đơn hàng bị huỷ <i className="fas fa-info-circle"></i></Tooltip>,

            align: "center",
            sorter: {
                compare: (a, b) => a.count_auto_cancel - b.count_auto_cancel,
                multiple: 3,
            },
        },

        {
            dataIndex: 'total_auto_cancel',
            title: <Tooltip className="show-tooltip" title='Tổng tiền Online lên đơn cho khách hàng có nhu cầu nhưng khách hàng không đến hệ thống tự huỷ.'> Tổng tiền đơn hàng huỷ <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.total_auto_cancel) - Number(b.total_auto_cancel),
                multiple: 1,
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Đơn hàng Sale Online tư vấn thành công, được ghi nhận khi khách hàng đồng ý đăng ký dịch vụ. *Có đầy đủ: Tên, số điện thoại, dịch vụ, số tiền cần thanh toán, cơ sở..'>
                Số đơn Pre-order <i className="fas fa-info-circle"></i>
            </Tooltip>,
            dataIndex: 'countOrder',
            align: "center",
            sorter: {
                compare: (a, b) => a.countOrder - b.countOrder,
                multiple: 3,
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Doanh số Pre-order là tổng số tiền của các đơn hàng được tư vấn và chốt thành công qua kênh Sale Online, trong đó khách hàng đã xác nhận đăng ký dịch vụ, có đầy đủ thông tin (tên, số điện thoại, dịch vụ, số tiền cần thanh toán, cơ sở...) và được ghi nhận làm căn cứ để tiếp nhận tại cơ sở.'> Doanh số Pre-order <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'totalPriceOrder',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.totalPriceOrder) - Number(b.totalPriceOrder),
                multiple: 1,
            },
        },
        {
            title: 'Tiền đã thu',
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>Tiền đã thu <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'paidOrder',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Tiền thực thu bán hàng',
            title: <Tooltip className="show-tooltip" title='Tiền đã thu trừ thuế'> Tiền thực thu bán hàng <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'paidOrderNoTax',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
        },
        {
            title: 'Số lượng lịch đặt thành công',
            title: <Tooltip className="show-tooltip" title='Số lịch Online đặt lịch cho khách hàng hoặc xác nhận lịch khách hàng đặt.'> Số lượng lịch đặt thành công <i className="fas fa-info-circle"></i></Tooltip>,
            dataIndex: 'bookings',
            align: "center",
            sorter: {
                compare: (a, b) => a.bookings - b.bookings,
                multiple: 2,
            },
        },
    ];
    const columns2 = [
        { dataIndex: 'user_name', title: 'Nhân viên', width: 150 ,   fixed: 'left' },
        {
            dataIndex: 'tong_thuan',
            title: <Tooltip className="show-tooltip" title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'> Doanh số thuần <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'paidThuan',
            title: <Tooltip className="show-tooltip" title='Số tiền khách hàng đã thanh toán hoá đơn được lên đơn trong khoảng thời gian chọn. Đơn hàng khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'> Thực thu đơn hàng thuần <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{convertCurrency(data)}</p>
                )
            },
            sorter: {
                compare: (a, b) =>Number(a.total_paid) - Number(b.total_paid),
                multiple: 1,
            },
        },
        {
            dataIndex: 'thuc_thu',
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'> Tiền thực thu nguồn Online <i className="fas fa-info-circle"></i></Tooltip>,
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
        },
        {
            // dataIndex: 'paidTriet',
            title: 'Triệt lông',
            align: "start",
            // width: 150 ,
            render: (data) => {
                return (
                    <div>
                        <p className="text1">
                            <Tooltip title="Tổng doanh số thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Tổng: {convertCurrency(data.triet_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title="Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Đã thu: {convertCurrency(data.triet_thu_thuan)}
                        </p>
                        <p className="text7">
                            <Tooltip title="Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.triet_thuc_thu)}
                        </p>
                    </div>
                );
            },
        },
        {
            // dataIndex: 'countDa',
            title: 'Da',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">
                            <Tooltip title="Tổng doanh số thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Tổng: {convertCurrency(data.da_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title="Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Đã thu: {convertCurrency(data.da_thu_thuan)}
                        </p>
                        <p className="text7">
                            <Tooltip title="Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.da_thuc_thu)}
                        </p>
                    </div>
                );
            },
        },
        {
            // dataIndex: 'paidTriet',
            title: 'Chăm sóc body',
            align: "start",
            // width: 150 ,
            render: (data) => {
                return (
                  <div>
                        <p className="text1">
                            <Tooltip title="Tổng doanh số thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Tổng: {convertCurrency(data.body_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title="Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Đã thu: {convertCurrency(data.body_thu_thuan)}
                        </p>
                        <p className="text7">
                            <Tooltip title="Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.body_thuc_thu)}
                        </p>
                  </div>
                );
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Mỹ phẩm',
            align: "start",
            render: (t,data) => {
                return (
                  <div>
                        <p className="text1">
                            <Tooltip title="Tổng doanh số thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                        Tổng: {convertCurrency(data.my_pham_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title="Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Đã thu: {convertCurrency(data.my_pham_thu_thuan)}
                        </p>
                        <p className="text7">
                            <Tooltip title="Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).">
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.my_pham_thuc_thu)}
                        </p>
                  </div>
                );
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Đầu triệt',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">
                            <Tooltip title='Tổng doanh số thuần của nhóm dịch vụ'><i className="fas fa-info-circle"></i></Tooltip> 
                            Tổng: {convertCurrency(data.dau_triet_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title='Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ'><i className="fas fa-info-circle"></i></Tooltip>
                            Đã thu: {convertCurrency(data.dau_triet_thu_thuan)}
                        </p>
                        <p className="text7">
                            <Tooltip title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).'>
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.dau_triet_thuc_thu)}
                        </p>
                    </div>
                )
            },
        },
        {
            // dataIndex: 'countKhac',
            title: 'Gội đầu',
            align: "start",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">
                            <Tooltip title='Tổng doanh số thuần của nhóm dịch vụ'><i className="fas fa-info-circle"></i></Tooltip> 
                            Tổng: {convertCurrency(data.goi_thuan)}
                        </p>
                        <p className="text3">
                            <Tooltip title='Tổng tiền đã thu từ đơn hàng thuần của nhóm dịch vụ'><i className="fas fa-info-circle"></i></Tooltip>
                            Đã thu: {convertCurrency(data.goi_thuan)}
                        </p>
                        <p className="text7"> 
                            <Tooltip title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Online bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy (Được dùng để tính hoa hồng nhân viên tư vấn).'>
                                <i className="fas fa-info-circle"></i>
                            </Tooltip>
                            Thực thu: {convertCurrency(data.goi_thuc_thu)}
                        </p>
                    </div>
                )
            },
        },
    ];

    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    return (
        <div className={`container-fluid ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                title={title} type={"total-sales-online"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        { label: 'Nhân viên', key: "user_name" },
                        { label: "Số đơn hàng", key: "countOrder" },
                        { label: "Số lượng dịch vụ", key: "countOrderItem" },
                        { label: "Doanh số tư vấn", key: `totalPriceOrder` },
                        { label: "Giá trị tb đơn hàng", key: `ratio` },
                        { label: "Tiền thực thu", key: `paidOrder` },
                        { label: "Số booking", key: `bookings` }
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <Row>
                    <Col xs={12}>
                        <Row className="h-100">
                            <Col md={6} lg={3} xs={12} className="mb-2">
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <div className={styles.textTag2}>Tổng quan: </div>
                                    <div className="d-flex justify-content-between p-2">
                                        <div>
                                            <p className={styles.textTag3}>
                                                <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'>
                                                    Tổng tiền đã thu: <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p> 
                                            <p className={styles.textTag3}>
                                                <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'>
                                                    Tổng thực thu bán hàng: <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p> 
                                            <p className={styles.textTag3}>
                                                <Tooltip title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'>
                                                    Tổng doanh số thuần: <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p> 
                                            <p className={styles.textTag3}>
                                                <Tooltip title='Số đơn hàng thuần là số lượng đơn hàng thực tế phát sinh doanh thu, sau khi loại trừ các đơn bị huỷ, hoàn tiền, hoặc không có giá trị thanh toán thực tế. Từ nguồn Online.'>
                                                    Số đơn hàng thuần: <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p>
                                            <p className={styles.textTag3}>
                                                <Tooltip title='Tổng số lượt dịch vụ thực tế tạo ra doanh thu, sau khi đã loại trừ các lượt dịch vụ được miễn phí, hoàn trả, hoặc không tính vào doanh số vì mục đích khuyến mãi/nội bộ.'>
                                                    Số dịch vụ thuần: <i className="fas fa-info-circle"></i>
                                                </Tooltip>
                                            </p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(totalPaid)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalPaidNoTax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.triet_thuan + totalThuanOb.da_thuan + totalThuanOb.body_thuan + totalThuanOb.my_pham_thuan + totalThuanOb.dau_triet_thuan + totalThuanOb.goi_thuan)}</p>
                                            <p className={styles.textTag3}> {totalOrder}</p>
                                            <p className={styles.textTag3}> {totalService}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col md={6} lg={3} xs={12} className="mb-2">
                                <Tag color="green" className="w-100 p-2 h-100">
                                    <div className={styles.textTag2}>
                                        <Tooltip title='Số tiền cần thu được chia theo nhóm dịch vụ sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Online.'>
                                            DOANH SỐ THUẦN NHÓM DỊCH VỤ: <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-between p-2">
                                        <div>
                                            <p className={styles.textTag3}>Triệt lông:</p> 
                                            <p className={styles.textTag3}>Da: </p> 
                                            <p className={styles.textTag3}>Chăm sóc body:</p>
                                            <p className={styles.textTag3}>Mỹ phẩm:</p>
                                            <p className={styles.textTag3}>Đầu triệt:</p>
                                            <p className={styles.textTag3}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.triet_thuan)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.da_thuan)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.body_thuan)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.my_pham_thuan)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.dau_triet_thuan)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThuanOb.goi_thuan)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col md={6} lg={3} xs={12} className="mb-2">
                                <Tag color="violet" className="w-100 p-2 h-100">
                                    <div className={styles.textTag2}>
                                        <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy. Được chia theo nhóm dịch vụ.'>
                                                TIỀN ĐÃ THU NHÓM DỊCH VỤ: <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-between p-2">
                                        <div>
                                            <p className={styles.textTag3}>Triệt lông:</p> 
                                            <p className={styles.textTag3}>Da: </p> 
                                            <p className={styles.textTag3}>Chăm sóc body:</p>
                                            <p className={styles.textTag3}>Mỹ phẩm:</p>
                                            <p className={styles.textTag3}>Đầu triệt:</p>
                                            <p className={styles.textTag3}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.triet_thuc_thu)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.da_thuc_thu)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.body_thuc_thu)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.my_pham_thuc_thu)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.dau_triet_thuc_thu)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThu.goi_thuc_thu)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col md={6} lg={3} xs={12} className="mb-2">
                                <Tag color="violet" className="w-100 p-2 h-100">
                                    <div className={styles.textTag2}>
                                        <Tooltip title='Tổng số tiền đã thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy. Được chia theo nhóm dịch vụ.'>
                                                TIỀN THỰC THU BÁN HÀNG NHÓM DỊCH VỤ: <i className="fas fa-info-circle"></i>
                                        </Tooltip>
                                    </div>
                                    <div className="d-flex justify-content-between p-2">
                                        <div>
                                            <p className={styles.textTag3}>Triệt lông:</p> 
                                            <p className={styles.textTag3}>Da: </p> 
                                            <p className={styles.textTag3}>Chăm sóc body:</p>
                                            <p className={styles.textTag3}>Mỹ phẩm:</p>
                                            <p className={styles.textTag3}>Đầu triệt:</p>
                                            <p className={styles.textTag3}>Gội đầu:</p>
                                        </div>
                                        <div className="ml-3">
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.triet_thuc_thu_no_tax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.da_thuc_thu_no_tax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.body_thuc_thu_no_tax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.my_pham_thuc_thu_no_tax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.dau_triet_thuc_thu_no_tax)}</p>
                                            <p className={styles.textTag3}>{convertCurrency(totalThucThuNoTax.goi_thuc_thu_no_tax)}</p>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xs={12}>
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Tabs defaultActiveKey="1">
                                <TabPane tab="Số liệu tổng quan" key="1">
                                    <Table 
                                        columns={columns} 
                                        dataSource={table}
                                        pagination={{ pageSize: 10 }}
                                        showSorterTooltip={{ title: '' }}
                                        scroll={{ x: columns.length*200, y: 600 }}
                                        bordered
                                        rowKey="userId"
                                    />
                                </TabPane>
                                <TabPane tab="Chi tiết nhóm dịch vụ" key="2">
                                    <Table 
                                        columns={columns2} 
                                        dataSource={arrayThuan}
                                        pagination={{ pageSize: 10 }}
                                        showSorterTooltip={{ title: '' }}
                                        scroll={{ x: columns.length*200, y: 600 }}
                                        bordered
                                        rowKey="user_id"
                                    />
                                </TabPane>
                            </Tabs>
                            
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div>
    )
}
export default ReportTvOnline